import { render, staticRenderFns } from "./PatientInformationTab.vue?vue&type=template&id=7381afbc&"
import script from "./PatientInformationTab.vue?vue&type=script&lang=js&"
export * from "./PatientInformationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports